import React from "react"
import {
  SettingsCard,
  SettingsCardTitle,
  SettingsCardContent,
} from "@modules/site/settings"
import { SiteSettingsSection, SiteSettingsSectionLabel } from "../constants"
import PublishReports from "./PublishReports"
import { useTriggerErrorAlert } from "@modules/ui/components/ErrorAlert"
import { Spacer } from "gatsby-interface"

export default function ReportsSection({
  siteId,
  siteName,
  permissions,
  buildsEnabled,
}) {
  const [setError, errorAlert] = useTriggerErrorAlert()

  return (
    <SettingsCard>
      <SettingsCardTitle>
        {SiteSettingsSectionLabel[SiteSettingsSection.Reports]}
      </SettingsCardTitle>

      <SettingsCardContent>
        <PublishReports
          siteId={siteId}
          siteName={siteName}
          permissionToEdit={permissions.sites.edit}
          buildsEnabled={buildsEnabled}
          setError={setError}
        />
        {errorAlert && (
          <React.Fragment>
            <Spacer size={7} />
            {errorAlert}
          </React.Fragment>
        )}
      </SettingsCardContent>
    </SettingsCard>
  )
}
